module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/protected-file-436c1438b0708967c0e3d6a845effd4e.svg";